import './App.css';
import React, {useRef} from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Main from './pages/Main';
import Payment from './pages/Payment';
import SetUpPassword from './pages/SetUpPassword';


function App() {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    // alert(sectionId)
    if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={< Main/>} />
          {/* <Route path='/subscribe/:name' element={<Payment/>} /> */}
          {/* <Route path='/setup' element={<SetUpPassword/>} /> */}
          <Route path="/pay/:invoiceId" element={<Payment />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
  
export default App;
